<div class="filter-container">
    <div class="filter-header">
        <h3>{{ 'DAY.FILTER.TITLE' | translate }}</h3>
    </div>
    <div class="filter-content">
        <mat-form-field appearance="outline" class="task-filter">
            <mat-select [(ngModel)]="selectedFilter" name="food">
                @for (filter of filterValues; track filter) {
                    <mat-option [value]="filter">
                        {{ 'DAY.FILTER.TYPES.' + filter | translate }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="category-filter">
            <mat-label>{{ 'DAY.FILTER.CATEGORIES' | translate }}</mat-label>
            <mat-select [formControl]="categoriesSelect" multiple>
                @for (category of categoryList; track category) {
                    <mat-option [value]="category">
                        {{ 'CATEGORY.' + category.toUpperCase() | translate }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-checkbox class="neutral-checkbox" [(ngModel)]="showNeutralTasks">
            {{ 'DAY.FILTER.SHOW_NEUTRAL' | translate }}
        </mat-checkbox>

    </div>

    <div class="filter-buttons">
        <button
                (click)="closeFilterDialog(false)"
                class="cancel action-button"
                mat-button>
            {{ 'GENERAL.CANCEL' | translate }}
        </button>

        <button
                (click)="closeFilterDialog(true)"
                class="apply action-button"
                mat-flat-button>
            {{ 'GENERAL.APPLY' | translate }}
        </button>
    </div>
</div>
